// Closed value sets baked into the cohort-activity dbt models. The channel
// taxonomy mirrors _shopify_match_channel (seed-driven, 'DTC E-Commerce' is
// the catch-all) and the bands mirror _shopify_first_order_value_band —
// any change there must ship together with this file.

export const LTV_COHORT_CHANNELS = [
  "DTC E-Commerce",
  "DTC Retail",
  "Subscription",
  "Third Party E-Commerce",
  "Third Party Retail",
] as const

export const LTV_COHORT_VALUE_BANDS = [
  "< $25",
  "$25 - $50",
  "$50 - $75",
  "$75 - $100",
  "$100 - $150",
  "$150 - $250",
  "$250+",
] as const

export const SKU_PREFIX_LEVELS = [1, 2, 3, 4, 5, 6] as const

/**
 * Which fan-out dimension the cohort is keyed by. Product, collection, and
 * SKU-prefix live in separate fan-out tables, so only ONE can be active per
 * query; channel and value band are plain dimensions on every table and
 * compose with any family.
 */
export type CohortFamily = "none" | "product" | "collection" | "sku"

export const COHORT_CUBES: Record<CohortFamily, string> = {
  none: "company_shopify_cohort_activity",
  product: "company_shopify_cohort_activity_product",
  collection: "company_shopify_cohort_activity_collection",
  sku: "company_shopify_cohort_activity_sku_prefix",
}

/**
 * total = accumulated net revenue including the first order itself;
 * incremental = repeat revenue only (first order subtracted).
 */
export type LtvMetricMode = "total" | "incremental"

export const FAMILY_OPTIONS: Array<{ value: CohortFamily; label: string }> = [
  { value: "none", label: "No product filter" },
  { value: "product", label: "First order product" },
  { value: "collection", label: "First order collection" },
  { value: "sku", label: "First order SKU prefix" },
]
